import {
    ADD_FAVOURITE_ORG,
    FETCH_ORG,
    FETCH_ORG_SUCCESS,
    FETCH_ORGS_SELECT_ORG,
    FETCH_ALL_ORG,
    FETCH_ALL_ORG_SUCCESS,
    FILTER_ORG,
    GET_ALL_ORG,
    GET_UNSELECTED_ALL_ORG,
    HANDLE_ORG_REQUEST_CLOSE,
    HIDE_ORG_LOADER,
    SHOW_ORG_LOADER,
    ON_ADD_ORG,
    ON_ALL_ORG_SELECT,
    ON_ORG_CLOSE,
    ON_ORG_SELECT,
    ON_DELETE_ORG,
    ON_DELETE_SELECTED_ORG,
    ON_FILTER_ORG_OPTION_SELECT,
    ON_SAVE_ORG,
    ON_SAVE_ORG_SUCCESS,
    ON_TOGGLE_ORG_DRAWER,
    SHOW_ORG_MESSAGE,
    UPDATE_SEARCH_ORG,
    ON_EMP_DASHBOARD,
    ON_ORG_SURVEY_DASHBOARD,
    ON_ORG_SURVEY_COMPARE_DASHBOARD,
    ON_ORG_DASHBOARD,
    ON_ORG_DASHBOARD_SUCCESS,
    ON_PROJECT_DASHBOARD,
    FETCH_ORG_STATISTICS,
    FETCH_ORG_STATISTICS_SUCCESS,
    ON_IMPERSONATE_DASHBOARD
} from 'constants/ActionTypes';

export const fetchOrgStatistics = (payload) => {
    return {
        type: FETCH_ORG_STATISTICS,
        payload,
    };
};
export const fetchOrgStatisticsSuccess = (payload) => {
    return {
        type: FETCH_ORG_STATISTICS_SUCCESS,
        payload,
    };
};
export const onOrgDashboard = () => {
    return {
        type: ON_ORG_DASHBOARD,
    };
};
export const fetchOrg = (orgid) => {
    return {
        type: FETCH_ORG,
        payload: orgid
    };
};
export const fetchOrgSuccess = (org) => {
    return {
        type: FETCH_ORG_SUCCESS,
        payload: org
    };
};
export const fetchOrgsSelectOrg = (orgid) => {
    return {
        type: FETCH_ORGS_SELECT_ORG,
        payload: orgid
    };
};
export const fetchOrgsAndSelectOrg = (orgid) => {
    return {
        type: FETCH_ORGS_SELECT_ORG,
        payload: orgid
    };
};
export const onOrgDashboardSuccess = (payload) => {
    return {
        type: ON_ORG_DASHBOARD_SUCCESS,
        payload
    };
};
export const fetchOrgs = () => {
    return {
        type: FETCH_ALL_ORG
    };
};
export const fetchOrgsSuccess = (orgs) => {
    return {
        type: FETCH_ALL_ORG_SUCCESS,
        payload: orgs
    };
};
export const showOrgMessage = (message) => {
    return {
        type: SHOW_ORG_MESSAGE,
        payload: message
    };
};
export const addFavouriteOrg = (data) => {
    return {
        type: ADD_FAVOURITE_ORG,
        payload: data
    };
};
export const onOrgSelect = (data) => {
    return {
        type: ON_ORG_SELECT,
        payload: data
    };
};
export const onEmpDashboard = (data) => {
    return {
        type: ON_EMP_DASHBOARD,
        payload: data
    };
};
export const onProjectDashboard = (data) => {
    return {
        type: ON_PROJECT_DASHBOARD,
        payload: data
    };
};
export const onImpersonateOrg = (data) => {
    return {
        type: ON_IMPERSONATE_DASHBOARD,
        payload: data
    };
};
export const onOrgSurveyDashboard = (data) => {
    return {
        type: ON_ORG_SURVEY_DASHBOARD,
        payload: data
    };
};
export const onOrgSurveyCompareDashboard = (data) => {
    return {
        type: ON_ORG_SURVEY_COMPARE_DASHBOARD,
        payload: data
    };
};
export const onAddOrg = () => {
    return {
        type: ON_ADD_ORG,
        payload: ''
    };
};
export const onOrgClose = () => {
    return {
        type: ON_ORG_CLOSE,
        payload: ''
    };
};
export const onFilterOrgOptionSelect = (option) => {
    return {
        type: ON_FILTER_ORG_OPTION_SELECT,
        payload: option
    };
};
export const onSaveOrg = (data) => {
    return {
        type: ON_SAVE_ORG,
        payload: data
    };
};
export const onSaveOrgSuccess = (data) => {
    return {
        type: ON_SAVE_ORG_SUCCESS,
        payload: data
    };
};
export const onDeleteOrg = (data) => {
    return {
        type: ON_DELETE_ORG,
        payload: data
    };
};
export const onDeleteSelectedOrg = () => {
    return {
        type: ON_DELETE_SELECTED_ORG,
        payload: ''
    };
};
export const filterOrg = (userName) => {
    return {
        type: FILTER_ORG,
        payload: userName
    };
};
export const getAllOrg = () => {
    return {
        type: GET_ALL_ORG,
        payload: ''
    };
};
export const getUnselectedAllOrg = () => {
    return {
        type: GET_UNSELECTED_ALL_ORG,
        payload: ''
    };
};
export const onAllOrgSelect = () => {
    return {
        type: ON_ALL_ORG_SELECT,
        payload: ''
    };
};
export const updateSearchOrg = (userName) => {
    return {
        type: UPDATE_SEARCH_ORG,
        payload: userName
    };
};
export const onToggleOrgDrawer = () => {
    return {
        type: ON_TOGGLE_ORG_DRAWER,
    };
};
export const handleOrgRequestClose = () => {
    return {
        type: HANDLE_ORG_REQUEST_CLOSE,
    };
};
export const showOrgLoader = () => {
    return {
        type: SHOW_ORG_LOADER,
    };
};
export const hideOrgLoader = () => {
    return {
        type: HIDE_ORG_LOADER,
    };
};



// WEBPACK FOOTER //
// ./actions/Organisation.js